const bindReviewScroller = (scroller) => {
  if (scroller.dataset.dsDragReady === 'true') return;
  scroller.dataset.dsDragReady = 'true';

  let startX = 0;
  let startScrollLeft = 0;
  let dragging = false;

  scroller.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch') return;
    dragging = true;
    startX = event.clientX;
    startScrollLeft = scroller.scrollLeft;
    scroller.classList.add('is-dragging');
    scroller.setPointerCapture(event.pointerId);
  });

  scroller.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    scroller.scrollLeft = startScrollLeft - (event.clientX - startX);
  });

  const stopDragging = (event) => {
    if (!dragging) return;
    dragging = false;
    scroller.classList.remove('is-dragging');
    if (scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
  };

  scroller.addEventListener('pointerup', stopDragging);
  scroller.addEventListener('pointercancel', stopDragging);
};

const bindAllReviewScrollers = (root = document) => {
  root.querySelectorAll('.ds-review-cards__scroller').forEach(bindReviewScroller);
};

bindAllReviewScrollers();
document.addEventListener('shopify:section:load', (event) => bindAllReviewScrollers(event.target));
